import {handleResponse} from "@/services/service-helpers"

const BASE_URL = `${import.meta.env.VITE_NBH_URL_ROOT}/api/auth/password-reset`

export async function requestPasswordReset(username: string): Promise<void> {
    const response = await fetch(`${BASE_URL}/request`, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({username}),
    })
    await handleResponse<void>(response)
}

export async function validateResetToken(token: string): Promise<{ valid: boolean }> {
    try {
        const response = await fetch(`${BASE_URL}/validate?token=${encodeURIComponent(token)}`, {
            method: "GET",
        })
        return await handleResponse<{ valid: boolean }>(response) as { valid: boolean }
    } catch {
        return {valid: false}
    }
}

// Routes through handleResponse so any non-OK response with a JSON body rejects with the parsed object
// (including validationIssues from the configurable password policy) rather than a flattened string.
// The page-level catch handles both the structured-finding case and the token-error case
// ({error: "Invalid or expired token"} from AuthenticationController).
export async function confirmPasswordReset(token: string, newPassword: string): Promise<void> {
    const response = await fetch(`${BASE_URL}/confirm`, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({token, newPassword}),
    })
    await handleResponse<void>(response)
}
